import { statementList } from './mock';

export default () => {
  return {
    statementList,
  };
};
